var TwilioServiceClientImpl = (function () {
    function TwilioServiceClientImpl(proxy) {
        this.proxy = proxy;
    }
    TwilioServiceClientImpl.prototype.sendMessage = function (to, from, body, mediaUrl) {
        return this.proxy.sendMessage(to, from, body, mediaUrl);
    };
    return TwilioServiceClientImpl;
}());
export default TwilioServiceClientImpl;
//# sourceMappingURL=TwilioServiceClientImpl.js.map